module.exports = __webpack_public_path__ + "img/404-error.ac0ba9c3.png";